import { NestedObjectsPathKeys, SortOptions } from '@connect-x-app/shared-types';

import { BaseSort } from './base-sort';
import { Sortable } from './sort';

export class SortAscending<
  T extends object = {
    [key: string]: unknown;
  },
>
  extends BaseSort<SortOptions.ASC, T>
  implements Sortable<T>
{
  override type: SortOptions.ASC = SortOptions.ASC;

  constructor(field: NestedObjectsPathKeys<Required<T>>) {
    super(field);
  }
}
